import React, { useEffect, useState } from 'react';
import { Icon } from '@fuxi/eevee-icon';
import { useCountDown } from 'ahooks';
import { Badge, Progress } from 'antd';

interface Props {
  type: 'software' | 'hardware';
}

const COUNTDOWN_TIME = 7000;

const PlayDeviceDetecting: React.FC<Props> = ({ type }) => {
  const [countdownTargetTime, setCountdownTargetTime] = useState(Date.now() + COUNTDOWN_TIME);

  const [countdown] = useCountDown({
    targetDate: countdownTargetTime,
    interval: 300,
    onEnd() {
      console.log('countdown end');
    },
  });

  useEffect(() => {
    if (type === 'hardware') {
      setCountdownTargetTime(Date.now() + COUNTDOWN_TIME);
    }
  }, [type]);

  return (
    <Progress
      type="dashboard"
      percent={(countdown / COUNTDOWN_TIME) * 100}
      strokeColor="#0055FF"
      format={() => (
        <Badge count={type === 'software' ? 1 : 2}>
          <Icon size={42} name="voice" color="#0055FF" />
        </Badge>
      )}
    />
  );
};

export default PlayDeviceDetecting;
